import React, { useEffect, useState } from "react";
import Breadcrumb from "../../../../utility/breadcrumb/Breadcrumb";
import useReferal from './useReferal';
import { referal } from '../../../../../images/index.js';
import {
  FacebookShareButton,
  WhatsappShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  TelegramShareButton,
  EmailShareButton,
  FacebookIcon,
  WhatsappIcon,
  LinkedinIcon,
  TwitterIcon,
  TelegramIcon,
  EmailIcon,
} from "react-share";

const Referal = () => {
  const { loading, referalcode, getReferalcode } = useReferal();

  useEffect(() => {
    getReferalcode();
  }, []);
  
  const location = window.location.protocol || window.location.host;
 
  const referralLink = referalcode || "Promo15";
  const baseUrl = location; //"https://gapalyze.com";
  const shareUrl = `${baseUrl}?ref=${referralLink}`;

  const shareText = `📊✨ Unlock Powerful Amazon Insights with GAPALYZE! ✨📊

  Hey! 👋 I’ve been using GAPALYZE – a smart tool that breaks down Amazon ads & product data into clear, actionable insights. 📈

  You can try it too with my exclusive referral code 👇

  🔐 Referral Code: *${referralLink}*  
  🎉 Get 15% OFF on refer you friends/family!

  🔗 Start exploring Amazon trends now:
  *${shareUrl}*

  ⏳ Limited time only – get ahead of your competition with data that makes a difference! 🚀📦`;


  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(referralLink).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <>
      <div className='without-datepicker-breadcrumb'>
      <Breadcrumb />
      </div>
      <div className="px-2" style={{ display: "flex", alignItems: "center", minHeight: "80vh" }}>
        <div className="container py-2 referral">
          <div className="row align-items-center rounded-4 overflow-hidden referral-card">
            {/* Right Image */}
            <div className="col-lg-6 col-md-12 p-0">
              <img
                src={referal}
                alt="Refer Banner"
                className="img-fluid w-100 object-fit-cover"
                style={{ maxHeight: '600px', minHeight: '300px', objectFit: 'cover' }}
              />
            </div>


            {/* Left Content */}
            <div className="col-lg-6 col-md-12 p-4 text-center">
              <h2 className="fw-bold custom-text-dark mb-2 referral-heading" style={{ letterSpacing: "2px" }}>
                GAPALYZE
              </h2>
              <h5 className="fw-semibold custom-text-dark mb-3 referral-sub-heading">Unlock Exclusive Savings</h5>
              <p className="custom-text-muted small mb-4 referral-text">
                Invite your friends to experience Throughout and receive 15% off for both of you
              </p>

              <div
                className="input-group input-group-sm justify-content-center mb-3"
                style={{ maxWidth: "300px", margin: "0 auto" }}
              >
                <input
                  type="text"
                  className="form-control text-start referral-text"
                  value={referralLink}
                  readOnly
                />
                <button className="btn btn-warning copy-btn" onClick={handleCopy}>
                  <i className={`bi ${copied ? "bi-check-circle text-success" : "bi-clipboard"}`}></i>
                </button>
              </div>

              <p className="small custom-text-muted mb-2 referral-text">Share this code with your friends</p>

              <div className="d-flex justify-content-center gap-3 flex-wrap mb-3">
                <FacebookShareButton url={shareUrl} quote={shareText}>
                  <FacebookIcon size={40} round />
                </FacebookShareButton>

                <WhatsappShareButton url={shareUrl} title={shareText}>
                  <WhatsappIcon size={40} round />
                </WhatsappShareButton>

                <LinkedinShareButton url={shareUrl} title="GAPALYZE Referral Offer" summary={shareText}>
                  <LinkedinIcon size={40} round />
                </LinkedinShareButton>

                <TwitterShareButton url={shareUrl} title={shareText}>
                  <TwitterIcon size={40} round />
                </TwitterShareButton>

                <TelegramShareButton url={shareUrl} title={shareText}>
                  <TelegramIcon size={40} round />
                </TelegramShareButton>

                <EmailShareButton url={shareUrl} subject="🎁 Save 15% on GAPALYZE!" body={shareText}>
                  <EmailIcon size={40} round />
                </EmailShareButton>
              </div>

              <p className="small custom-text-muted referral-text">You'll see a preview before sharing</p>
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default Referal;
